import React from 'react'

interface Props {
  color: string
  height: string
  width: string
}

// Self-contained CSS spinner replacing react-loading@2, which pre-bundled its
// own copy of React 16 and threw "A React Element from an older version of
// React was rendered" under React 19. Mirrors the old type="balls" look
// (three bouncing dots) and keeps the color/height/width prop API.
const Loading: React.FC<Props> = ({ color, height, width }) => {
  return (
    <div
      role="status"
      aria-label="loading"
      style={{
        width,
        height,
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.35em',
      }}
    >
      <style>
        {`@keyframes wx-loading-bounce {
            0%, 80%, 100% { transform: scale(0); opacity: 0.4; }
            40% { transform: scale(1); opacity: 1; }
          }`}
      </style>
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          style={{
            display: 'inline-block',
            width: '0.75em',
            height: '0.75em',
            borderRadius: '50%',
            backgroundColor: color,
            animation: 'wx-loading-bounce 1.4s ease-in-out infinite both',
            animationDelay: `${i * 0.16}s`,
          }}
        />
      ))}
    </div>
  )
}

export default Loading
